export enum SLIDER {
  WRAPPER = "sliderWrapper",
  BUTTON_LEFT = "sliderButtonLeft",
  BUTTON_RIGHT = "sliderButtonRight",
  THUMB = "sliderThumb",
}
